module.exports = __webpack_public_path__ + "img/bg-cpc-wallet.c8c35a5e.png";